import { useMemo } from "react";
import type { AnalysisMeasure, AnalysisObject } from "@repo/shared";
import { ItemsAnalysisTable } from "./ItemsAnalysisTable";

interface MeasuresAnalysisTableProps {
  analysisId: string;
  measures: AnalysisMeasure[];
  objects: AnalysisObject[];
}

export function MeasuresAnalysisTable({
  analysisId,
  measures,
  objects,
}: MeasuresAnalysisTableProps) {
  const rows = useMemo(
    () =>
      measures.map((m) => ({
        id: m.id,
        name: m.title,
        definition: m.expression ?? "",
        usage: m.usedInCount,
        used: m.usedInCount > 0,
        broken: m.isBroken,
        indirect: m.isIndirectUsage,
        orphan: m.isOrphanUsageOnly,
        usedIn: m.usedIn,
        issues: m.expressionIssues,
      })),
    [measures],
  );
  return (
    <ItemsAnalysisTable analysisId={analysisId} scope="measures" rows={rows} objects={objects} />
  );
}
